import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
    isAuthenticated: false,
    isLoading: false,
  },
  reducers: {
    loadingUser: (state) => {
      state.isLoading = true;
    },
    loadUser: (state, action) => {
      state.isAuthenticated = true;
      state.currentUser = action.payload;
      state.isLoading = false;
    },
    noUser: (state) => {
      state.isAuthenticated = false;
      state.currentUser = null;
      state.isLoading = false;
    },
    loginUser: (state, action) => {
      state.isAuthenticated = true;
      state.currentUser = action.payload.others;
      state.isLoading = false;
    },
    logoutUser: (state) => {
      state.isAuthenticated = false;
      state.currentUser = null;
      state.isLoading = false;
    },
  },
});

export const { loadingUser, loadUser, loginUser, noUser, logoutUser } =
  userSlice.actions;
export default userSlice.reducer;
